import { createActions, } from 'redux-actions';

export default createActions({
  PAYOUTS: {
    SET: null,
    ADD: null,
    RESET: null,
  },
});
